export const SALES_COMMISSION_ACTIONS_ELEMENT_ID = 'sales-commission-actions';
